import { TIME_UNIT_CONVERT_FACTOR } from 'constants/general';

/** Student heartbeat cadence (~1 req / 10s; server throttles similarly). */
export const CLASS_SESSION_HEARTBEAT_INTERVAL_MS = 10_000;

/** Default `tasks_version` when the session payload omits it. */
export const INITIAL_CLASS_SESSION_TASKS_VERSION = 1;

/**
 * Student / desktop command-bus channel (`private-<userId>`).
 * CLASS TodoPlayer also binds checklist updates here (not on presence-class).
 */
export const PRIVATE_USER_CHANNEL_PREFIX = 'private-';

const MINUTES_PER_DAY =
  TIME_UNIT_CONVERT_FACTOR.ONE_DAY_AS_SECONDS /
  TIME_UNIT_CONVERT_FACTOR.ONE_MINUTE_AS_SECONDS;

/** Slider / day-timeline knobs for teacher class-session start window. */
export const CLASS_SESSION_WINDOW = {
  MINUTES_PER_DAY,
  SNAP_MINUTES: 15,
  MIN_GAP_MINUTES: 30,
  TICK_STEP_MINUTES: TIME_UNIT_CONVERT_FACTOR.ONE_HOUR_AS_MINUTES * 3,
  MAX_MINUTE: MINUTES_PER_DAY - 1
} as const;

export const CLASS_ORDERED_TASKS = {
  PROGRESS: {
    COMPLETE: 100,
    EMPTY: 0
  },
  EMPTY_COUNT: {
    COMPLETED: 0,
    TOTAL: 0
  }
} as const;
